import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import _ from "lodash";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }

    .notice{
        color: #333;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 10px;
        margin-top: 10px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    button{
        width: 100px;
        border-radius: 3px;
        background-color: var(--redColor1);
        color: #fff;
        border: none;
        font-weight: 600;

        &.cancel{
            background-color: #efefef;
            color: #333;
        }
    }
`;

export function FragmentDeletePurchaseUrlModal({
    open,
    onClose,
    purchaseUrl,
    onConfirm
}) {
    const [formData, setFormData] = useState(_.cloneDeep(purchaseUrl))

    const handleSubmit = async () => {
        onConfirm(formData);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>구매처 URL 삭제</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
                    <StyledBody>
                        <div className='notice'>
                            해당 구매처 URL을 삭제하시겠습니까?
                        </div>
                    </StyledBody>
                    <StyledFooter>
                        <CustomBlockButton
                            type='button'
                            className='cancel'
                            onClick={onClose}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='submit'
                        >
                            확인
                        </CustomBlockButton>
                    </StyledFooter>
                </form>
            </CustomDialog>
        </>
    );
}